.drawer {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-top: 1px solid var(--tuna-palette-divider);
  background: var(--tuna-palette-background-default);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.modalFooter {
  font-size: 0.85rem;
  color: var(--tuna-palette-text-secondary);
  margin: 0 0 12px 0;
  font-style: italic;
}

.prefixStrip {
  font-size: 0.9rem;
  margin-bottom: 12px;
  color: var(--tuna-palette-text-secondary);
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
